import React from 'react';
import Icon from '../../../components/AppIcon';

const MembershipBenefits = () => {
  const benefitCategories = [
    {
      id: 1,
      title: "Leadership Development",
      description: "Build essential leadership skills through structured training and real-world application",
      icon: "Crown",
      color: "bg-primary",
      benefits: [
        "Executive board positions and committee leadership roles",
        "Public speaking opportunities at meetings and events",
        "Project management experience with measurable outcomes",
        "Mentorship from experienced Leo and Lions Club leaders",
        "Leadership training workshops and certification programs"
      ]
    },
    {
      id: 2,
      title: "Professional Growth",
      description: "Accelerate your career through networking and skill development opportunities",
      icon: "TrendingUp",
      color: "bg-secondary",
      benefits: [
        "Network with young professionals across diverse industries",
        "Develop communication and presentation skills",
        "Gain experience in event planning and coordination",
        "Build your professional portfolio with service achievements",
        "Access to career development resources and workshops"
      ]
    },
    {
      id: 3,
      title: "Community Impact",
      description: "Create meaningful change while building lasting partnerships in the community",
      icon: "Heart",
      color: "bg-accent",
      benefits: [
        "Lead impactful service projects addressing real community needs",
        "Partner with established organizations and government agencies",
        "Develop fundraising and resource mobilization skills",
        "Create lasting positive change in underserved communities",
        "Build relationships with community leaders and stakeholders"
      ]
    }
  ];

  return (
    <section className="py-20 bg-surface">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground">
            Why Join Leo Circle Colombo?
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Membership offers a unique combination of personal development, professional growth, and community impact opportunities designed for ambitious young leaders.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {benefitCategories.map((category) => (
            <div key={category.id} className="bg-card rounded-xl p-8 shadow-lg hover:shadow-xl transition-smooth">
              <div className="space-y-6">
                <div className="flex items-center space-x-4">
                  <div className={`w-12 h-12 ${category.color} rounded-lg flex items-center justify-center`}>
                    <Icon name={category.icon} size={24} className="text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-foreground">{category.title}</h3>
                  </div>
                </div>
                
                <p className="text-muted-foreground leading-relaxed">
                  {category.description}
                </p>
                
                <ul className="space-y-3">
                  {category.benefits.map((benefit, index) => (
                    <li key={index} className="flex items-start space-x-3">
                      <Icon name="Check" size={16} className="text-accent mt-1 flex-shrink-0" />
                      <span className="text-sm text-foreground leading-relaxed">{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-primary to-purple-800 rounded-2xl p-8 lg:p-12 text-center text-white">
          <div className="max-w-3xl mx-auto space-y-6">
            <h3 className="text-2xl lg:text-3xl font-bold">
              Ready to Start Your Leadership Journey?
            </h3>
            <p className="text-lg text-purple-100">
              Join a community of driven young professionals who are making a difference while building their careers and developing essential leadership skills.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
              <div className="flex items-center space-x-2 bg-white/10 rounded-lg px-4 py-2">
                <Icon name="Calendar" size={20} className="text-secondary" />
                <span>Monthly meetings</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/10 rounded-lg px-4 py-2">
                <Icon name="Clock" size={20} className="text-secondary" />
                <span>Flexible commitment</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/10 rounded-lg px-4 py-2">
                <Icon name="Globe" size={20} className="text-secondary" />
                <span>Global network</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MembershipBenefits;